/* ---------------------------------------

    -- スクロール連動はここ

--------------------------------------- */
export default class Pararax {
    constructor() {
        this.$target
        this.start = false /* trueで処理が開始される */
        this.paraPoint = []

        this.scInc = 0
        /*  ステータスをセット */
        this.status = []

        this.active = false
    }
    init() {
        this.$target = document.querySelectorAll('.js__sc-pararax')

        this.paraPoint = []
        this.status = []

        if (this.$target[0]) {
            this.start = true

            for (let i in this.$target) {
                if (this.$target[i].nodeType != 1) continue // dom要素以外は処理止める
                this.status[i] = {
                    rate: Useragnt.mobile
                        ? Math.min(
                            this.$target[i].getAttribute('data-rate') / 2,
                            0.2
                        )
                        : this.$target[i].getAttribute('data-rate'),
                    type: '',
                }
                let _t

                for (let j in this.$target[i].classList[0]) {
                    if (typeof this.$target[i].classList[j] !== 'string')
                        continue
                    if (this.$target[i].classList[j].match(/js__dir-/g))
                        _t = this.$target[i].classList[j].replace('js__', '')
                    this.status[i].type = _t

                    if (Useragnt.mobile && this.status[i].type == 'dir-x')
                        this.status[i].rate = 0
                }
            }
        } else {
            this.start = false
        }
    }
    mot(inc, progress) {
        if (!this.start || !this.paraPoint[0]) return
        this.scInc = inc

        for (let i in this.paraPoint) {
            if (this.paraPoint[i].start < inc && this.paraPoint[i].end > inc) {
                const pInc =
                    (inc - this.paraPoint[i].start) * this.status[i].rate
                if (this.status[i].type == 'dir-y-minus') {
                    TweenLite.set(this.$target[i], { y: pInc })
                } else if (this.status[i].type == 'dir-x') {
                    TweenLite.set(this.$target[i], { x: -pInc })
                } else if (this.status[i].type == 'dir-z') {
                    TweenLite.set(this.$target[i], { scale: 1.3 - pInc / 200 })
                } else {
                    TweenLite.set(this.$target[i], { y: -pInc })
                }
            }
        }
    }

    resize(winH) {
        if (!this.$target[0]) return
        this.paraPoint = []
        for (let i in this.$target) {
            if (this.$target[i].nodeType != 1) break // dom要素以外は処理止める
            const rect = this.$target[i].getBoundingClientRect()

            this.paraPoint[i] = {
                base: rect.top,
                start: Useragnt.mobile
                    ? Math.max(0, rect.top - window.innerHeight * 1.5)
                    : Math.max(0, rect.top + this.scInc - window.innerHeight),
                end: Useragnt.mobile
                    ? rect.top + window.innerHeight
                    : rect.top + this.scInc + window.innerHeight,
            }

            TweenLite.set(this.$target[i], {
                top:
                    this.status[i].type == 'dir-y-minus'
                        ? this.status[i]
                        ? -window.innerHeight * this.status[i].rate
                        : -window.innerHeight
                        : this.status[i]
                        ? window.innerHeight * 0.5 * this.status[i].rate
                        : window.innerHeight,
            })
        }
    }
}
